// extracted by mini-css-extract-plugin
export default {"summary-container":"StockAuditReportSummary_summary-container__BYEWX","summary-ctas":"StockAuditReportSummary_summary-ctas__7H4J-"};